export default "__VITE_ASSET__510eb4c8__"